/**
 * Genesis Phase 1 posting flow id constants — no @engines dependency (Vite client safe).
 */

export const GENESIS_POSTING_FLOW_IDS = [
  'flow_genesis_posting_stream_execution',
  'flow_genesis_posting_finance_flow',
  'flow_genesis_posting_finance_state',
] as const;

export type GenesisPostingFlowId = (typeof GENESIS_POSTING_FLOW_IDS)[number];
